import { initThemeMode } from "flowbite-react";
import "./src/styles/global.css";

initThemeMode();
